import http from '../utils/request'

/**
 * 审计日志 API — 对应后端 AuditLogController (/api/audit-log)
 */

/** 查询日志列表 */
export const getAuditLogs = (params) => http.get('/audit-log', { params })

/** 获取模块列表 */
export const getAuditModules = () => http.get('/audit-log/modules')

/** 记录页面访问 */
export const recordPageView = (data) => http.post('/audit-log/page-view', data)
